// Registers every locale on the shared moment instance, for the whole app.
//
// moment ships only `en` and loads the rest through a `require('./locale/' + name)` the bundler
// cannot resolve, so without this `moment.localeData('de-DE')` is null in the browser and
// `DateUtilities` silently falls back to an ISO date and a 24h clock for everyone outside `en`.
// Registration is global — a single side-effect import here serves every `import moment from
// 'moment'` in the app, so no other import has to change. It must be loaded before
// `AppComponent` calls `DateUtilities.setLocale`, which is why it sits in the entry point.
//
// The whole set rather than a chosen few: the locale comes from the technician's OS, so it is not
// ours to enumerate. This file ends with `moment.locale('en')`, the same default AppComponent sets.
import 'moment/min/locales';
import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
    enableProdMode();
}

// This is a hack to make Errors play nicely with JSON.stringify. If we don't do this, we will not have the errors
// printed in Chrome while debugging the app.
// Code taken from https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
if (!('toJSON' in Error.prototype)) {
    Object.defineProperty(Error.prototype, 'toJSON', {
        value: function <T>() {
            const alt: { [keys: string]: T } = {};

            Object.getOwnPropertyNames(this).forEach(function (key) {
                alt[key] = this[key];
            }, this);

            return alt;
        },
        configurable: true,
        writable: true,
    });
}

const initApp = (): void => {
    platformBrowserDynamic()
        .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
        .catch((err) => console.error(err));
};

initApp();
